import { render, staticRenderFns } from "./RamsMetadataPanel.vue?vue&type=template&id=18872678&"
import script from "./RamsMetadataPanel.vue?vue&type=script&lang=js&"
export * from "./RamsMetadataPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports